import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, IdCard } from "lucide-react";
import { BRAND, errMsg, inr } from "./constants";

function GuestDetail({ gid, authFetch, API }) {
  const [d, setD] = useState(null);
  useEffect(() => { authFetch({ url: `${API}/homestay/guests/${gid}` }).then((r) => setD(r.data)).catch(() => {}); }, [gid, authFetch, API]);
  const viewAadhaar = async () => {
    try {
      const r = await authFetch({ url: `${API}/homestay/guests/${gid}/aadhaar`, responseType: "blob" });
      window.open(URL.createObjectURL(r.data), "_blank");
    } catch (e) { toast.error("No Aadhaar on file"); }
  };
  if (!d) return null;
  return (
    <div data-testid={`guest-detail-${gid}`} className="mt-2 rounded-xl p-3 text-xs" style={{ background: "#F6F8F7" }}>
      {d.guest.has_aadhaar && <button data-testid={`guest-aadhaar-btn-${gid}`} onClick={viewAadhaar} className="mb-2 rounded-full border px-3 py-1 font-bold inline-flex items-center gap-1" style={{ borderColor: BRAND.green, color: BRAND.green }}><IdCard className="w-3.5 h-3.5" /> View Aadhaar</button>}
      <div className="font-bold mb-1" style={{ color: BRAND.green }}>Booking history ({d.bookings.length})</div>
      {d.bookings.map((b) => <div key={b.id} className="flex justify-between py-0.5"><span>{b.check_in?.slice(0, 10)} → {b.check_out?.slice(0, 10) || "open"} · {b.bed_label || ""}</span><span>{inr(b.amount_inr)} · {b.status}</span></div>)}
    </div>
  );
}

export function GuestsPanel({ pid, authFetch, API }) {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  const load = useCallback((query = "") => authFetch({ url: `${API}/homestay/properties/${pid}/guests${query ? `?q=${encodeURIComponent(query)}` : ""}` })
    .then((r) => setItems(r.data.items)).catch((e) => toast.error(errMsg(e, "Could not load guests"))), [pid, authFetch, API]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="guests-panel" className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-sm font-bold" style={{ color: BRAND.green }}>Guests ({items.length})</div>
        <form onSubmit={(e) => { e.preventDefault(); load(q); }} className="flex gap-2">
          <input data-testid="guests-search-input" className="rounded-xl border-2 px-3 py-1.5 text-sm" placeholder="Name, mobile or Guest ID" value={q} onChange={(e) => setQ(e.target.value)} />
          <button data-testid="guests-search-btn" className="rounded-full px-3 text-white" style={{ background: BRAND.green }} aria-label="Search"><Search className="w-4 h-4" /></button>
        </form>
      </div>
      <div className="mt-2 divide-y" style={{ borderColor: BRAND.line }}>
        {items.length === 0 && <div className="text-xs py-3" style={{ color: BRAND.muted }}>No guests yet — they're added from New Booking.</div>}
        {items.map((g) => (
          <div key={g.id} className="py-2.5" data-testid={`guest-row-${g.id}`}>
            <button onClick={() => setOpen(open === g.id ? null : g.id)} className="w-full text-left flex justify-between gap-2 text-sm">
              <span><b>{g.name}</b> <span className="chip text-[10px]">{g.guest_code}</span><span className="block text-xs" style={{ color: BRAND.muted }}>{g.mobile} · from {g.city}{g.has_aadhaar ? " · Aadhaar ✓" : ""}</span></span>
              <span className="text-xs" style={{ color: BRAND.muted }}>{g.bookings} stay{g.bookings === 1 ? "" : "s"}</span>
            </button>
            {open === g.id && <GuestDetail gid={g.id} authFetch={authFetch} API={API} />}
          </div>
        ))}
      </div>
    </div>
  );
}
